import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

interface SectionSubHeaderProps {
    attestationName: string,
    text: string,
    values?: Record<string, React.ReactNode | string>
}

const SectionSubHeader = (props: SectionSubHeaderProps): ReactElement | null => {
    const {
        attestationName,
        text,
        values: rawValues
    } = props;

    const dataTestId = `ssap-attestation-section-subheader-${ attestationName }`;

    if(!text) {
        return null;
    }

    return (
        <h4 data-testid = { dataTestId } className = 'margin-bottom-1em margin-top-1em' >
            <strong>
                <FormattedMessage id = { text } values = { rawValues } />
            </strong>
        </h4>
    );
};

export default SectionSubHeader;